import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import axios from "axios";

/**
 * Selector reutilizable de Grupos de clientes.
 * Se muestra ANTES de que un reporte jale su informacion: el usuario elige
 * uno o varios grupos y hasta entonces se dispara la carga del reporte.
 *
 * Props:
 *  - isOpen: boolean, si el modal esta visible
 *  - onConfirm: (idsGrupos: string[], grupos: [{_id,name}]) => void
 *  - onClose: () => void  (opcional; solo si allowClose)
 *  - allowClose: boolean  (permite cerrar sin elegir; util para "cambiar grupos")
 *  - initialSelected: string[] (opcional, para reabrir con seleccion previa)
 */
function SelectorGrupos({
  isOpen,
  onConfirm,
  onClose,
  allowClose = false,
  initialSelected = [],
}) {
  const URL_GRUPOS = process.env.REACT_APP_URL_GRUPOS;
  const [grupos, setGrupos] = useState([]);
  const [selected, setSelected] = useState(initialSelected);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    setCargando(true);
    axios
      .get(URL_GRUPOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const activos = (res.data || []).filter((g) => g.is_active === "Si");
        activos.sort((a, b) => (a.name > b.name ? 1 : -1));
        setGrupos(activos);
        setCargando(false);
      })
      .catch((err) => {
        console.log(err);
        setCargando(false);
      });
  }, []);

  useEffect(() => {
    if (isOpen) setSelected(initialSelected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const toggle = (id) =>
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );

  const todos = () => setSelected(grupos.map((g) => g._id));
  const ninguno = () => setSelected([]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={allowClose ? onClose : undefined}
      backdrop="static"
      scrollable
    >
      <ModalHeader toggle={allowClose ? onClose : undefined}>
        Selecciona los grupos del reporte
      </ModalHeader>
      <ModalBody>
        <p style={{ color: "#666", marginBottom: 8 }}>
          El reporte se generara unicamente con la informacion de los grupos que
          elijas.
        </p>
        <div style={{ marginBottom: 8 }}>
          <Button color="link" size="sm" className="p-0 mr-3" onClick={todos}>
            Seleccionar todos
          </Button>
          <Button color="link" size="sm" className="p-0" onClick={ninguno}>
            Limpiar
          </Button>
        </div>
        {cargando ? (
          <p>Cargando grupos...</p>
        ) : grupos.length === 0 ? (
          <p>No hay grupos activos.</p>
        ) : (
          <div
            style={{
              border: "1px solid #e0e0e0",
              borderRadius: 4,
              maxHeight: 260,
              overflowY: "auto",
              padding: "4px 10px",
            }}
          >
            {grupos.map((g) => (
              <label
                key={g._id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "6px 0",
                  margin: 0,
                  cursor: "pointer",
                  fontWeight: "normal",
                }}
              >
                <input
                  type="checkbox"
                  checked={selected.includes(g._id)}
                  onChange={() => toggle(g._id)}
                  style={{
                    width: 16,
                    height: 16,
                    marginRight: 10,
                    flex: "0 0 auto",
                  }}
                />
                <span>{g.name}</span>
              </label>
            ))}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        {allowClose && (
          <Button color="secondary" onClick={onClose}>
            Cancelar
          </Button>
        )}
        <Button
          color="primary"
          disabled={!selected.length}
          onClick={() => onConfirm(selected, grupos.filter((g) => selected.includes(g._id)))}
        >
          Generar reporte
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default SelectorGrupos;
